import {
  Component, HostBinding, Input,
  Output, EventEmitter,
} from '@angular/core';


@Component({
  moduleId: module.id,
  selector: 'generic-pagination-v2',
  templateUrl: 'generic-pagination-v2.component.html',
  styleUrls: ['generic-pagination-v2.component.scss'],
})

export class GenericPaginationV2Component {

  @Input() perNumbers: number[] = [25, 50, 100];
  @Input() page: number = 1;
  @Input() per: number = 25;
  @Input() total: number = 0;
  @Input() disabled: boolean = false;
  @Input() dropdown: boolean = true;
  @Input() perName: string = 'page';
  @Input() ghostValue: string = 'pagination';
  // ['numbering-right', ...]
  @Input() style: string = '';
  @Input() dropup: boolean = false;

  @Output() pageChanged = new EventEmitter();
  @Output() itemsPerPageChanged = new EventEmitter();

  /*******************************************
   * COMPONENT GETTERS
   *******************************************/

  get totalFormatted(): string {
    return String(this.total);
  }

  get startRange(): number {
    if (this.page === 1) { return 1; }
    return ((this.page - 1) * this.per) + 1;
  }

  get endRange(): number {
    let endRange = this.total;
    if (this.per < this.total) {
      endRange = this.page * this.per;
      if (endRange > this.total) { return this.total; }
    }
    return endRange;
  }

  get isPrevDisabled(): boolean {
    return this.page === 1;
  }

  get isNextDisabled(): boolean {
    return this.endRange >= this.total;
  }

  get lastPage(): number {
    return Math.ceil(this.total / this.per);
  }

  /*******************************************
   * COMPONENT PUBLIC METHODS
   *******************************************/

  changeItemsPerPage(itemsPerPage: number) {
    this.per = itemsPerPage;
    this.itemsPerPageChanged.emit(itemsPerPage);
  }

  /*******************************************
   * COMPONENT EVENMT HANDLERS
   *******************************************/

  onPaginationBtnClick(direction: number) {
    if (direction === 1 && this.isNextDisabled) { return; }
    if (direction === -1 && this.isPrevDisabled) { return; }
    this.page += direction;
    this.pageChanged.emit(this.page);
  }

  onCurrPageChanged(page: number) {
    this.page = page;
    this.pageChanged.emit(this.page);
  }

}
